import { defineStore } from 'pinia';
import { useGlobalStore } from '@/store/global-store-base';
import { useApi } from '@lib/api';

export const useTimelines = defineStore('timelines', () => {
  const api = useApi();

  const globalStoreBase = useGlobalStore({
    load: api.timeline_ListTimelines,
    dto: 'TimelineDto',
    create: api.timeline_CreateTimeline,
    update: api.timeline_UpdateTimeline,
    delete: api.timeline_DeleteTimeline,
    usage: api.timeline_GetUsage,
    signalR: 'TimelineUpdate',
  });

  return { ...globalStoreBase };
});
